import { createFileRoute } from "@tanstack/react-router";
import { CollapseDrawerProvider } from "src/contexts/CollapseDrawerContext";
import DashboardLayout from "src/layouts/dashboard/DashboardLayout";
import AuthGuard from "src/providers/AuthProvider/AuthGuard";

export const Route = createFileRoute("/_dashboard/_authenticated")({
	component: () => (
		<AuthGuard>
			<CollapseDrawerProvider>
				<DashboardLayout />
			</CollapseDrawerProvider>
		</AuthGuard>
	)
});
